<script setup lang="ts">
// Native form POST so secrets (e.g. invitation tokens) travel in the body, never in a URL.
defineProps<{ action: string, fields: Record<string, string> }>()
</script>

<template>
  <form method="post" :action="action">
    <input v-for="(value, name) in fields" :key="name" type="hidden" :name="name" :value="value">
    <slot />
  </form>
</template>
